import type { CSSProperties, HTMLAttributes, ReactNode } from "react";

type GridGap = "sm" | "md" | "lg" | number;

const GAP_MAP: Record<Exclude<GridGap, number>, string> = {
  sm: "10px",
  md: "14px",
  lg: "16px",
};

interface GridProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  minItemWidth?: number;
  gap?: GridGap;
  columns?: number;
  variant?: "grid" | "list";
}

export function Grid({ children, minItemWidth = 220, gap = "md", columns, variant = "grid", className = "", style, ...props }: GridProps) {
  const cssVars = {
    "--mmm-grid-gap": typeof gap === "number" ? `${gap}px` : GAP_MAP[gap],
    "--mmm-grid-min": `${minItemWidth}px`,
    "--mmm-grid-columns": columns ? `repeat(${columns}, minmax(0, 1fr))` : undefined,
  } as CSSProperties;

  return (
    <div className={`mmm-grid mmm-grid--${variant} ${className}`.trim()} style={{ ...cssVars, ...style }} {...props}>
      {children}
    </div>
  );
}
